import { render, staticRenderFns } from "./standingButtonDistribute.vue?vue&type=template&id=35005e6e&"
import script from "./standingButtonDistribute.vue?vue&type=script&lang=js&"
export * from "./standingButtonDistribute.vue?vue&type=script&lang=js&"
import style0 from "./standingButtonDistribute.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports